import React from 'react';

import FolderSelector, {DEFAULT_PROJECT_FOLDER_LABEL_TEXT} from 'file-browser/FolderSelector';
import getTestProps from 'test/lib/cypress/getTestProps';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import {Optional} from 'util/Types';

export interface ConfirmAaSequenceAlignmentPaneProps {
  shouldCreateNewAaSequence: boolean;
  proteinName: string | null;
  onSetAaSequenceName: (proteinName: string) => void;
  folderId: Optional<string>;
  onSetFolderId: (folderId: string) => void;
}

export default function ConfirmAaSequenceAlignmentPane(
  props: ConfirmAaSequenceAlignmentPaneProps
): JSX.Element {
  return (
    <div>
      {props.shouldCreateNewAaSequence && (
        <div>
          <Row>
            <Col md={8}>
              <FormGroup>
                <Label>Consensus AA sequence name</Label>
                <FormInput
                  placeholder="Untitled AA sequence"
                  value={props.proteinName || ''}
                  onChange={(e) => {
                    props.onSetAaSequenceName(e.target.value);
                  }}
                  focusOnMount={true}
                  {...getTestProps({component: 'ConfirmProteinAlignmentPane', element: 'nameField'})}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>{DEFAULT_PROJECT_FOLDER_LABEL_TEXT}</Label>
                <FolderSelector
                  showInventory={true}
                  value={props.folderId}
                  onChange={(e) => {
                    props.onSetFolderId(e.target.value);
                  }}
                  unsetOnFetchFail={true}
                />
              </FormGroup>
            </Col>
          </Row>
          <hr />
        </div>
      )}
      <span>Alignment computed using Clustal Omega.</span>
    </div>
  );
}
